import React from 'react'
import "./button.css"
import { PropaneSharp } from '@mui/icons-material';

const Button = (props) => {
  return (
    <div className="hero_buttons">
      <button className="hero_btn">{props.name}</button>
    </div>
  );
}

export default Button